export const DAY_RANGES: Record<string, number> = {
  '30d': 30,
  '60d': 60,
  '90d': 90,
}
export const CHART_HEIGHT = 360
